module.exports = __webpack_public_path__ + "static/media/orangePointer.f8f651d9.svg";